import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <section className="relative overflow-hidden bg-foreground-950 py-20 text-background-50 md:py-28">
      <div className="blueprint absolute inset-0 opacity-40" />
      <div className="relative mx-auto w-full max-w-shell px-4 md:px-6">
        <p className="font-label text-[11px] uppercase tracking-[0.24em] text-primary-400">
          Fehler 404
        </p>
        <h1 className="mt-5 max-w-2xl font-heading text-[32px] font-extrabold leading-[1.05] tracking-tightest sm:text-[42px] md:text-[54px]">
          Diese Seite gibt es nicht — oder nicht mehr.
        </h1>
        <p className="mt-5 max-w-xl text-[14px] leading-relaxed text-background-300 md:text-[16px]">
          Vielleicht hat sich die Adresse geändert. Über die Navigation oder die Startseite finden
          Sie unsere Produkte und Kontaktdaten.
        </p>
        <div className="mt-9 flex flex-col gap-3 sm:flex-row">
          <Link
            to="/"
            className="inline-flex items-center justify-center gap-2 whitespace-nowrap bg-primary-500 px-6 py-3.5 font-heading text-[11.5px] font-bold uppercase tracking-[0.14em] text-background-50 transition-colors hover:bg-primary-600"
          >
            Zur Startseite
            <i className="ri-arrow-right-line text-[14px]" />
          </Link>
          <Link
            to="/produkte"
            className="inline-flex items-center justify-center gap-2 whitespace-nowrap border border-foreground-700 px-6 py-3.5 font-heading text-[11.5px] font-bold uppercase tracking-[0.14em] text-background-100 transition-colors hover:border-background-400"
          >
            Produkte ansehen
          </Link>
        </div>
      </div>
    </section>
  );
}